export const config = {
  base: 'https://proactiv.demo-sites.me/submissions',
  products: 'https://proactiv.demo-sites.me/products',
  refresh: 'https://proactiv.demo-sites.me/refresh',
  a: 'test',
  b: 'this'
};
